import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box
} from '@mui/material';

interface LegalModalProps {
    open: boolean;
    onClose: () => void;
    title: string;
    content: string;
    onAgree?: () => void;
}

export const LegalModal: React.FC<LegalModalProps> = ({ open, onClose, title, content, onAgree }) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth scroll="paper">
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {title}
            </DialogTitle>
            <DialogContent dividers>
                <Box sx={{ whiteSpace: 'pre-line' }}>
                    {/* 
                       Simple markdown-like rendering 
                       In a real app, use react-markdown if available. 
                       Here we just split by double newline for paragraphs.
                    */}
                    {content.split('\n').map((line, index) => {
                        if (line.startsWith('# ')) {
                            return <Typography key={index} variant="h5" gutterBottom sx={{ mt: 2, fontWeight: 'bold' }}>{line.replace('# ', '')}</Typography>;
                        }
                        if (line.startsWith('## ')) {
                            return <Typography key={index} variant="h6" gutterBottom sx={{ mt: 2, fontWeight: 'bold' }}>{line.replace('## ', '')}</Typography>;
                        }
                        if (line.startsWith('### ')) {
                            return <Typography key={index} variant="subtitle1" gutterBottom sx={{ mt: 1, fontWeight: 'bold' }}>{line.replace('### ', '')}</Typography>;
                        }
                        if (line.startsWith('* ') || line.startsWith('- ')) {
                            return (
                                <Box key={index} component="li" sx={{ ml: 2, typography: 'body2' }}>
                                    {line.replace(/^[\*\-]\s/, '')}
                                </Box>
                            );
                        }
                        // Default paragraph
                        if (line.trim() === '') return <br key={index} />;

                        return <Typography key={index} variant="body2" paragraph>{line}</Typography>;
                    })}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="inherit">Close</Button>
                {onAgree && (
                    <Button onClick={onAgree} variant="contained" color="primary">
                        I Agree
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
};
